var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7319 0.735446C3.11818 0.171518 2.17484 0.171518 1.56113 0.735446C1.53599 0.758541 1.50916 0.785378 1.47432 0.820228L0.95078 1.34377C0.423964 1.87058 0.202811 2.63003 0.364431 3.35732C1.28141 7.48374 4.50406 10.7064 8.63048 11.6234C9.35777 11.785 10.1172 11.5638 10.644 11.037L11.1675 10.5135C11.2024 10.4787 11.2292 10.4518 11.2524 10.4267C11.8163 9.81296 11.8163 8.86962 11.2524 8.2559C11.2292 8.23075 11.2024 8.20391 11.1675 8.16904L10.3105 7.31197C9.7154 6.71692 8.81676 6.54673 8.04532 6.883C7.60367 7.07551 7.0892 6.97807 6.74853 6.63741L5.3504 5.23927C5.00973 4.8986 4.9123 4.38413 5.10481 3.94248C5.44108 3.17105 5.27089 2.27241 4.67583 1.67735L3.81872 0.820237C3.78387 0.785383 3.75704 0.758543 3.7319 0.735446Z",
    fill: "#919DA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallicon);
export default __webpack_public_path__ + "static/media/callicon.dd896a6897635385ad929b01597f56b2.svg";
export { ForwardRef as ReactComponent };